import { render } from "./MyWebsiteDirectory.vue?vue&type=template&id=3415e59e"
import script from "./MyWebsiteDirectory.vue?vue&type=script&lang=js"
export * from "./MyWebsiteDirectory.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/halisclock/releases/44/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__